import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import PackageDetails from './PackageDetails';
import NotFoundPage from '../../components/home/NotFoundPage';
import OrderSummary from './OrderSummary';

const UpSellAhcNavigator = ({ loginState, authToken, history }) => {
  if (loginState !== 'LOGGED_IN' || !authToken) {
    history.push('/');
    return null;
  }

  return (
    <Switch>
      <Route
        path="/ahc-upsell/package-details"
        exact
        component={PackageDetails}
      />
      <Route path="/ahc-upsell/order-summary" exact component={OrderSummary} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
});

export default connect(mapStateToProps)(UpSellAhcNavigator);

